export const columnData = {
  Id: { name: 'Código', widthCol: '10%' },
  JobType: { name: 'Tipo de exportación', widthCol: '30%' },
  DateStarted: { name: 'Fecha de inicio', widthCol: '30%' },
  DateFinished: { name: 'Fecha de fin', widthCol: '30%' },
  Status: { name: 'Estado', widthCol: '20%' }
}
